<template>
  <header class="conversation-toolbar">
    <div class="conversation-toolbar__brand">
      <button
        class="conversation-toolbar__menu"
        type="button"
        aria-label="Menu"
        :aria-expanded="mobileMenuOpen"
        @click="$emit('mobile-menu')"
      >
        <CustomImg :src="menuIcon" alt="" />
      </button>
      <button class="conversation-toolbar__title" type="button" @click="$emit('new-chat')">
        {{ title }}
      </button>
      <form class="conversation-toolbar__search" @submit.prevent="submitSearch">
        <CustomImg :src="searchIcon" alt="" />
        <input v-model="searchQuery" type="search" :placeholder="t('ai.chat.search')" />
      </form>
      <button class="conversation-toolbar__new" type="button" :title="t('ai.chat.new')" @click="$emit('new-chat')">
        <CustomImg :src="editIcon" alt="" />
      </button>
    </div>
    <button class="conversation-toolbar__close" type="button" @click="$emit('close')">
      <CustomImg :src="closeIcon" alt="" />
    </button>
  </header>
</template>

<script setup lang="ts">
import CustomImg from '@/components/CustomImg.vue';
import closeIcon from '@/assets/images/ai/cls.svg';
import editIcon from '@/assets/images/ai/edit.svg';
import menuIcon from '@/assets/images/ai/menu.png';
import searchIcon from '@/assets/images/ai/search.svg';
import { ref } from 'vue';
import type { Translate } from './types';

defineProps<{
  t: Translate;
  title: string;
  mobileMenuOpen?: boolean;
}>();

const emit = defineEmits<{
  'home': [];
  'new-chat': [];
  'close': [];
  'regular-search': [query: string];
  'mobile-menu': [];
}>();
const searchQuery = ref('');

const submitSearch = () => {
  const query = searchQuery.value.trim();
  if (query) emit('regular-search', query);
};
</script>

<style scoped lang="scss">
.conversation-toolbar {
  position: sticky;
  top: 0;
  z-index: 15;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  min-height: 76px;
  padding: 14px 32px 10px 25px;
  border-bottom: 1px solid #eee;
  background: #fff;
}

.conversation-toolbar__brand {
  display: flex;
  align-items: center;
  gap: 22px;
}

.conversation-toolbar__title {
  position: relative;
  padding: 0;
  border: 0;
  color: inherit;
  background: transparent;
  font-size: 24px;
  font-weight: 700;
  cursor: pointer;
}

.conversation-toolbar__menu {
  display: none;
  width: 20px;
  height: 32px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  place-items: center;

  img {
    display: block;
    width: 18px;
    height: auto;
  }
}

.conversation-toolbar__search {
  position: relative;

  img {
    position: absolute;
    top: 50%;
    left: 16px;
    width: 18px;
    transform: translateY(-50%);
  }

  input {
    width: 260px;
    height: 40px;
    padding: 0 12px 0 46px;
    border: 1px solid #e5e5e5;
    border-radius: 999px;
    outline: 0;
  }
}

.conversation-toolbar__new,
.conversation-toolbar__close {
  display: grid;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  place-items: center;

  img { width: 18px; }
}

@media (max-width: 900px) {
  .conversation-toolbar__search { display: none; }
  .conversation-toolbar__menu { display: grid; }
}

@media (max-width: 600px) {
  .conversation-toolbar {
    min-height: 60px;
    padding: 10px 15px;
  }

  .conversation-toolbar__brand {
    gap: 12px;

    .conversation-toolbar__title { font-size: 20px; }
  }
}
</style>
